import React, { useContext } from 'react'
import { IoMdCheckmark } from 'react-icons/io'
import { MdCancel } from 'react-icons/md'
import { ImCross } from "react-icons/im";
import Public from './Public';
import { BasePopupContext } from '../../../hooks/usePopup';
import { DATE_FORMAT_SERVER, POPUP_LARGE, POPUP_SMALL, STATUS_ACCEPTED, STATUS_REJECTED } from '../../../constants';
import { DateTime } from 'luxon';
import { FormattedMessage } from 'react-intl';

const Actions = ({ refreshListing, item, deliverableId }) => {
    const { setPopup } = useContext(BasePopupContext);

    const handleAccept = (e) => {
        e.stopPropagation()
        setPopup({
            heading: <FormattedMessage id="make_public" defaultMessage={"Make Public"} />,
            component: <Public refreshListing={refreshListing} deliverableId={deliverableId} item={item} />,
            size: POPUP_SMALL
        })
    }
    
    return (
        <>

            <div className='flex flex-row items-center'>

                <div className='w-full flex gap-x-1'>
                    {/* <button
                        onClick={(e) => handleReject(e)}
                        className={`w-full py-1 inline-flex space-x-2 items-center justify-center hover:-translate-y-1 transition-all duration-300 text-sm bg-red-500/70 text-white   rounded-md`}>
                        <span>Reject</span>
                        <ImCross className='text-sm' />
                    </button> */}

                    <button
                        onClick={(e) => handleAccept(e)}
                        className={` w-full inline-flex space-x-2 items-center justify-center py-1 hover:-translate-y-1 transition-all duration-300  text-sm bg-primary text-white   rounded-md`}>
                        <span><FormattedMessage id="public" defaultMessage={"Public"} /></span>
                        <IoMdCheckmark className='text-xl' />
                    </button>
                </div>

            </div>




        </>
    )
}

export default Actions